// extracted by mini-css-extract-plugin
export default {"middle-div-container":"RenderLogPage_middle-div-container__mHXsg","table-container":"RenderLogPage_table-container__lcpEd"};